<template>
  <button
    type="button"
    aria-label="Scrolle zum Inhaltsanfang"
    class="cursor-pointer"
    @click="scrollTo()"
  >
    <IconScrollCTA class="h-full" />
  </button>
</template>

<script lang="ts">
export default {
  methods: {
    scrollTo() {
      const selector = '[scroll-to-index="0"]'
      const element: HTMLElement = document.querySelector(selector)!
      if (!element) {
        return
      }
      const headerOffset = 250
      const elementPosition = element.offsetTop
      const offsetPosition = elementPosition - headerOffset
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      })
    },
  },
}
</script>
